export default __webpack_public_path__ + "static/media/jioLogo.81dae860.png";